export default __webpack_public_path__ + "static/media/emre-mater.10572993.png";